export const TENANT_ID = 'reference'; // NEW APP TODO: Replace with the appropriate tenant.
export const APP_ID = 'eos-web';

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'demoHomePage$root', // NEW APP TODO: Replace tenant specific node id. This is a demo home masonry container.
  ROOT_NODE_ID_SUPPORT_PAGE: 'support$root',
  ROOT_NODE_ID_MY_CAREGIVERS: 'core$caregiver$landingPage$root',
  ROOT_NODE_ID_CAREGIVER_HOME: 'core$caregiver$caregiverHome$root',
  ROOT_NODE_ID_SETUP_MARKET_EXPERIENCE: 'setupMarketExperience$root',
};
